
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import {
  Add, 
  Close
} from "@mui/icons-material";
import { Tooltip, Fab } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  ModelBase 
} from "@models";
import { 
  EquipmentPack, 
  EquipmentPackItem,
  Item,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import StringBox from "@components/input/strings/StringBox";

import SelectBaseItemBox from "@dndComponents/select/SelectBaseItemBox";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import LoadingBox from "@components/input/LoadingBox";
import ButtonBox from "@components/input/buttons/ButtonBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function EquipmentPackEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<EquipmentPack>(api.applyWorkingOn(new EquipmentPack()));
  const [change_time, setChangeTime] = useState(0);
  const [items, setItems] = useState<Item[]>([]);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    setLoading(true);
    api.getSetOfObjects({ data_types: ["item"] }).then(res => {
      setItems(res.item as Item[]);
      if (id && id !== "") {
        api.getObjectsOld("equipment_pack").then(res => {
          const equipment_packs = res as EquipmentPack[];
          const objFinder = equipment_packs.find(a => a._id === id);
          if (objFinder) {
            setObj(objFinder);
            setChangeTime(common_util.get_time_number());
            setLoading(false);
          }
        });
      } else {
        // It's here from clicking Create on index.  
        // If the user is not admin, then we need to give the floating feature their id as owner or it will be disabled.
        const new_obj = obj.clone();
        if (api.user && !api.user.admin && obj.name === "" && obj.owner_id === "") {
          new_obj.owner_id = api.user._id;
        }
        setObj(new_obj);
        setChangeTime(common_util.get_time_number());
      }
    });
    
    setFetched(true);
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("equipment_pack", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/equipment_pack");
  //     });
  //   }
  // }

  const parse = () => {
    let pieces: string[] = [];
    if (obj.description.includes("\n")) {
      pieces = obj.description.split("\n").map(o => o.toLocaleLowerCase().trim());
    } else {
      pieces = obj.description.split(",").map(o => o.toLocaleLowerCase().trim());
    }
    const ignore_us = ["includes", "a", "an", "the", "and", "of"];
    const new_obj = obj;
    for (const piece of pieces) {
      let count = 1;
      let item = items.find(o => o.name.toLocaleLowerCase() === piece);
      if (!item) {
        const fixer = common_util.replaceAll(common_util.replaceAll(common_util.replaceAll(piece, "(", ""), ")", ""), ".", "").trim();
        const pieces2 = fixer.split(" ");
        let finder = [...items];
        let last = [...finder];
        let i = 0;
        while (finder.length !== 1 && i < pieces2.length) {
          let p = pieces2[i];
          const num = +p;
          if (!isNaN(num)) {
            count = num;
          } else if (!ignore_us.includes(p)) {
            finder = finder.filter(o => o.name.toLocaleLowerCase().includes(p));
            if (finder.length === 0) {
              finder = [...last];
              if (p.endsWith("s")) {
                // debugger;
                // It may be a plural and we want the singular.
                p = p.substring(0, p.length - 1);
                finder = finder.filter(o => o.name.toLocaleLowerCase().includes(p));
                if (finder.length === 0) {
                  finder = [...last];
                  if (p.endsWith("e")) {
                    // It may be that the plural adds es instead of just s
                    p = p.substring(0, p.length - 1);
                    finder = finder.filter(o => o.name.toLocaleLowerCase().includes(p));
                    if (finder.length === 0) {
                      finder = [...last];
                    } else {
                      last = [...finder];
                    }
                  }
                } else {
                  last = [...finder];
                }
              }
            } else {
              last = [...finder];
            }
          }
          ++i;
        }
        if (finder.length > 1) {
          // This is for situations like "hammer", which sees warhammer, light hammer, and hammer.
          i = 0;
          while (finder.length !== 1 && i < pieces2.length) {
            const p = pieces2[i];
            const num = +p;
            if (!isNaN(num)) {
              // count = num;
            } else if (!ignore_us.includes(p)) {
              finder = finder.filter(o => o.name.toLocaleLowerCase() === p);
              if (finder.length === 0) {
                finder = [...last];
              } else {
                last = [...finder];
              }
            }
            ++i;
          }
        }
        if (finder.length === 1) {
          item = finder[0];
        }
      }
      if (item) {
        const item_id = item._id;
        if (new_obj.items.filter(o => o.item_id === item_id).length === 0) {
          const ep_item = new EquipmentPackItem();
          ep_item.item_id = item._id;
          if (count === 50 && item.name.toLocaleLowerCase().includes("rope")) {
            count = 1;
          }
          ep_item.count = count;
          new_obj.items.push(ep_item);
        }
      }
    }
    setObj(new_obj);
    setChangeTime(common_util.get_time_number());
  }

  const height = window.innerHeight - 64;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else { 
    return (
      <ModelBaseInput 
        obj={obj}
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: ModelBase) => {
          if (changed instanceof EquipmentPack) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
            setChangeTime(common_util.get_time_number());
          }
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 3
            }}>
            <ButtonBox
              name="Parse Description"
              disabled={disabled}
              onClick={parse}
            />
          </Grid>
          <Grid
            size={{
              xs: 9
            }}>
            <StringBox 
              value={`${obj.cost}`} 
              name="Cost (in GP)"
              disabled={disabled}
              type="number"
              onBlur={(value: string) => {
                const new_obj = obj;
                new_obj.cost = +value;
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <span className="header">
              Items
            </span>
            { !disabled &&
              <Tooltip title={`Add Item`}>
                <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                  onClick={ () => {
                    const new_obj = obj;
                    const item = new EquipmentPackItem();
                    new_obj.items.push(item);
                    setObj(new_obj);
                    setChangeTime(common_util.get_time_number());
                  }}>
                  <Add/>
                </Fab>
              </Tooltip>
            } 
          </Grid>
          { obj.items.map((item, key) => {
            return (
              <Grid
                key={key}
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 6
                  }}>
                  <SelectBaseItemBox 
                    name="Item"
                    value={item.item_id}
                    disabled={disabled}
                    onChange={(id: string) => {
                      item.item_id = id;
                      const new_obj = obj;
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                    }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 4
                  }}>
                  <StringBox
                    value={`${item.count}`} 
                    name="Count"
                    type="number"
                    disabled={disabled}
                    onBlur={(value: string) => {
                      item.count = +value;
                      const new_obj = obj;
                      setObj(new_obj);
                      setChangeTime(common_util.get_time_number());
                    }}
                  />
                </Grid>
                { !disabled &&
                  <Grid
                    size={{
                      xs: 2
                    }}>
                    <Tooltip title={`Delete Item`}>
                      <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                        onClick={ () => {
                          const new_obj = obj;
                          obj.items = obj.items.filter(o => o.id !== item.id);
                          setObj(new_obj);
                          setChangeTime(common_util.get_time_number());
                        }}>
                        <Close/>
                      </Fab>
                    </Tooltip> 
                  </Grid>
                }
              </Grid>
            );
          })}
        </Grid>
      </ModelBaseInput>
    ); 
  }
}
